import { useState } from '#imports'

/**
 * Helper to track routes that have already been visited (server-side and client-side).
 *
 * Routes are identified by their hash, which is based on the translation keys they depend on
 * (see ~~/.translations/hash-by-route.js). Route names are not used for identification.
 *
 * This is used to deduplicate the `/:locale/:app/translations/:hash` HTTP requests inside the
 * `loadRouteTranslations.global` middleware. When navigating to a route that has already been
 * visited, or to a route that shares the same translation hash (e.g., product page and master
 * product page), the middleware can skip the translations fetch.
 */
export function useVisitedRoutes() {
  const visitedRoutes = useState<string[]>('i18n-visited-routes-hash', () => [])

  function visitRoute(routeHash: string) {
    if (visitedRoutes.value.includes(routeHash)) {
      return
    }

    visitedRoutes.value.push(routeHash)
  }

  function hasBeenVisited(routeHash: string) {
    return visitedRoutes.value.includes(routeHash)
  }

  return {
    hasBeenVisited,
    visitRoute,
  }
}
